import styled from 'styled-components';
import Colors from 'library/constants/colors';
import { IconBase } from 'library/styles/icon';
import { TransitionConfig, ShadowSlight } from 'library/constants/styles-config';

const ImageOverlay = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  opacity: 0;
  padding-top: 3px;
  text-align: left;
  background-image: linear-gradient(#2D3132, rgba(0, 0, 0, 0));
  background-size: 100% 54px;
  background-repeat: no-repeat;
  transition: opacity ${TransitionConfig};
`;

const Icon = styled(IconBase)`
  color: ${Colors.shade05};

  &:hover {
    color: ${Colors.shade08};
  }

  &.icon-options-vertical {
    float: right;
  }
`;

const Container = styled.div`
  width: 184px;
  padding: 12px;
  overflow: hidden;
  box-sizing: border-box;
  
  &.selected {
    background-color: ${Colors.shade07};
    
    ${ImageOverlay} {
      opacity: 1;
      background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0));
      background-color: rgba(${Colors.blueRgb}, 0.8);
    }
    
    ${Icon}.icon-check-inverse {
      color: ${Colors.shade08};      
    }
  }

  img {
    display: block;
    max-width: 100%;
    border-radius: 8px;
  }
  
  h3 {
    margin-top: 9px;
    margin-bottom: 3px;
  }
`;

const ImageWrapper = styled.div`
  position: relative;
  overflow: hidden;
  padding-top: 35px;
  padding-bottom: 35px;
  text-align: center;
  border-radius: 8px;
  cursor: pointer;
  box-shadow: ${ShadowSlight};
  background-color: ${Colors.shade08};
  filter: drop-shadow(0px 2px 8px rgba(45, 49, 50, 0.16));
  
  &:hover {
    > div {
      opacity: 1;
    }
  }
`;

export {
  Container, ImageWrapper, ImageOverlay, Icon,
};
